/** @jsxImportSource @emotion/react */
import React from 'react'
import { StylesObject } from "types"
import { Widget } from '../../widgets'
import { Carousel } from 'components'

//
// 3rd party websites can embed free widgets in an iFrame
// This container renders a carousel of widget without headers/footers
//

const WidgetCarousel = () => {

  return (
    <div css={styles.container}>
      <Carousel autoStep>
        <Widget
          id="regional-price-map"
          disableFullScreen
          showAttribution
          fadeIn
          icon={false}
        />
        <Widget
          id="carbon-dial"
          disableFullScreen
          showAttribution
          icon={false}
        />
        <Widget
          id="wind-forecast-graph"
          disableFullScreen
          showAttribution
          fadeIn
          icon={false}
        />
        <Widget
          id="stacked-generation-graph"
          disableFullScreen
          showAttribution
          fadeIn
          icon={false}
        />
        <Widget
          id="previous-day-prices-graph"
          disableFullScreen
          showAttribution
          fadeIn
          icon={false}
        />
      </Carousel>
    </div>
  )
}

export const styles = {
  // the carousel should fill the available height/width of the iframe
  container: theme => ({
    // from Widget fullscreen
    maxWidth: '100vw',
    maxHeight: '100vh',
    '& .widget-container': {
      overflowY: 'hidden',
      '& .MuiCardHeader-root': {
        [theme.breakpoints.only('xs')]: {
          padding: 5,
          '& .MuiCardHeader-avatar': {
            marginRight: 5,
          },
          '& .logo': {
            height: 15,
            width: 60
          }
        },
      },
      '& .MuiCardHeader-title': {
        fontSize: 'clamp(11px, 2.8vw, 17px)',
      },
      '& .MuiCardHeader-subheader': {
        fontSize: 'clamp(10px, 2.4vw, 13px)',
      },
      '& .MuiCardContent-root': {
        paddingBottom: 10,
      }
    },
    '& .map': {
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      '& svg': {
        maxHeight: 'min(100vw, 100vh)',
        maxWidth: 'min(100vw, 100vh)',
      }
    },
    // from WidgetContainer fullscreen
    '& .graph': {
      aspectRatio: 'unset',
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(100vh - 140px)',
      [theme.breakpoints.only('xs')]: {
        height: 'calc(100vh - 100px)',
      },
      '& .tooltip-list': {
        '& .MuiSvgIcon-root': {
          width: '0.8em',
          height: '0.8em',
        },
        '& .MuiTypography-root': {
          fontSize: 'clamp(10px, 2vw, 15px)',
        }
      },
      '& .recharts-responsive-container': {
        flex: 1
      },
      '& .legend': {
        [theme.breakpoints.only('xs')]: {
          marginTop: 0,
          paddingLeft: 20,
        }
      },
      '& .legend-item': {
        // the legend takes a moment to calculate how many columns it should display
        // if its too late and the graph has already rendered using all remaining height then the legend will not have enough space
        // setting a default minimum width seems to work
        // the smallest iframe from Energynews is 486px wide
        minWidth: 100,
        '& .MuiFormControlLabel-label': {
          fontSize: 'clamp(10px, 2vw, 15px)',
        },
        '& .MuiSvgIcon-root': {
          width: 'clamp(14px, 2.5vw, 20px)',
          height: 'clamp(14px, 2.5vw, 20px)',
        },
        '& .MuiCheckbox-root': {
          padding: 5,
        }
      }
    },
    '.carousel .MuiMobileStepper-root': {
      backgroundColor: '#0c3345 !important',
      '& svg': {
        paddingTop: 5,
        // height: '0.8em',
        // width: '0.8em',
        [theme.breakpoints.only('xs')]: {
          fontSize: 20
        }
      }
    }
  })
} as StylesObject

export default WidgetCarousel